import React, { FunctionComponent, useContext } from "react";
import { FormattedMessage } from "react-intl-phraseapp";
import { BasePlan, UserLanguage } from "../../../@types";
import { AppContext } from "../../../app/store";
import { HelpDrawerWrapper } from "../../../components";
import { newBasicHelperDrawerAnalytics } from "../../../components/BasicHelperDrawerAnalytics";
import { getPlanName, useTranslate } from "../../../helpers";
import englishTranslations from "../../../translations/en-US.json";

const YearOverYearWhatsNew: FunctionComponent<{
  currentPlanYear: string;
  currentCoverage: BasePlan;
  language: UserLanguage;
  className?: string;
}> = ({ currentPlanYear, currentCoverage, language, className }) => {
  const t = useTranslate();
  const { dispatch } = useContext(AppContext);

  return (
    <div className={`ds-l-md-col--6 ${className}`}>
      <p className="ds-u-margin-y--0 ds-u-font-weight--semibold">
        <FormattedMessage
          id="yoy.whats_new.plan_changes"
          values={{ year: currentPlanYear + 1 }}
        />
      </p>
      <h2 className="ds-u-margin-y--0">
        <FormattedMessage
          id="yoy.whats_new.whats_new"
          values={{ year: currentPlanYear + 1 }}
        />
      </h2>
      <p className="ds-u-margin-y--0 ds-u-margin-top--1">
        <FormattedMessage
          id="yoy.whats_new.each_fall"
          values={{
            currentYear: currentPlanYear,
            nextYear: currentPlanYear + 1,
          }}
        />
      </p>
      <p>
        <HelpDrawerWrapper
          toggleText={t("yoy.whats_new.toggle_text")}
          drawerTitle={t("yoy.whats_new.drawer_title")}
          toggleClassName="ds-u-text-align--left"
          mctAnalytics={newBasicHelperDrawerAnalytics({
            clickText: englishTranslations["yoy.whats_new.toggle_text"],
            dispatch,
          })}
        >
          <>
            <p>{t("yoy.whats_new.before_you_decide")}</p>
            <ul>
              <li>{t("yoy.whats_new.benefits_changing")}</li>
              <li>{t("yoy.whats_new.drugs_changing")}</li>
              <li>{t("yoy.whats_new.pharmacy_in_network")}</li>
              <li>{t("yoy.whats_new.premium_changing")}</li>
              <li>{t("yoy.whats_new.copayments")}</li>
              <li>{t("yoy.whats_new.plan_doesnt_offer")}</li>
              <li>{t("yoy.whats_new.happy_current_plan")}</li>
            </ul>
          </>
        </HelpDrawerWrapper>
      </p>
      <p>
        <FormattedMessage
          id="yoy.whats_new.explore_other_options"
          values={{ currentPlan: getPlanName(currentCoverage, language) }}
        />
      </p>
    </div>
  );
};

export default YearOverYearWhatsNew;
